import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    paperPadding: {
      padding: 15,
    },
    tabsHolder: {
      background: 'transparent',
      color: 'blue',
      '& .MuiTab-textColorInherit': {
        opacity: 1,
      },
    },
    selectedTab: {
      background: props.color2,
      color: 'white'
    },
    customerContainer: {
      marginTop: 30,
      marginLeft: -10,
      width: 'calc(100% + 20px)',
    },
    paperContainer: {
      padding: 15,
      margin: '0px 10px',
      ':not(:last-child)': {
        marginBottom: 10,
      }
    },
    fixMargins: {
      marginTop: 15,
      width: 'calc(100% + 20px)',
    },

    //customer invoice list
    customerInvoiceListContainer: {
      marginTop: 30,
    },
    customerInvoiceListHeader: {
      padding: '15px 15px 0px 15px',
      color: '#374151',
      fontSize: 20,
      fontWeight: 400,
      '& p': {
        padding: '10px 0px',
      },
      '& .forceUppercase': {
        textTransform: 'uppercase',
        marginBottom: 20
      },
      '& span': {
        color: props.color2,
        textTransform: 'capitalize'
      }
    },
    //customer invoice detail
    customerInvoiceDetailContainer: {
      marginTop: 30,
      display: 'flex',
      justifyContent: 'flex-end',
      marginLeft: -10,
      width: 'calc(100% + 20px)',
      '& div': {
        maxWidth: 150,

      }
    },
    paginationContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: 'calc(100% + 20px)',
      marginLeft: -10
    },
    editSupplierConnectionAddContainer: {
      marginTop: 30,
      display: 'flex',
      justifyContent: 'flex-end',
      marginLeft: -10,
      width: 'calc(100% + 20px)',
      '& div': {
        maxWidth: 300,
      }
    },
    saveButton: {
      marginTop: 20,
      display: 'flex',
      justifyContent: 'flex-end',
      '& button': {
        maxWidth: 150,
      }
    },

    customerInvoiceListContent: {
      width: 'calc(100% + 20px)',
    },

    '@media (max-width: 600px)': {
      customerContainer: {
        maxWidth: '100%',
        margin: 0,
        marginLeft: 0,
      },
      customerInvoiceDetailContainer: {
        justifyContent: 'flex-start',
        width: '100%',
        margin: 0,
        '& div': {
          maxWidth: '100%',
        }
      },

      customerInvoiceListHeader: {

        color: 'var(--text-strong)',
        fontSize: 20,
        fontWeight: 400,
        '& .forceUppercase': {
          lineHeight: 1.25,
          marginBottom: 8,
          padding: 0,
          width: '100%',
          padding: 5,
        },
      },

        customerInvoiceListContainer: {
          maxWidth: '100%',
          margin: 0,
          paddingBottom: 20,
          overflowX: 'hidden',
        },
        paginationContainer: {
          width: '100%',
          margin: 0,
        },
        editSupplierConnectionAddContainer: {
          width: '100%',
          margin: 0,
          '& div': {
            maxWidth: '100%',
          }
        },
        paperContainer: {
          width: '100%',
          padding: 15,
          margin: 0,
          ':not(:last-child)': {
            margin: 0,
          }
        },
        fixMargins: {
          margin: 0,
          width: '100%',
          maxWidth: '100%',
        },

        customerInvoiceListContent: {
          marginTop: 20,
          width: '100%',
          overflowX: 'hidden',
        },

      },


    }));
  return styles();
}
export default theme;

